export default __webpack_public_path__ + "static/media/ca_5.b7bee166.png";